export default __webpack_public_path__ + "static/media/portfolio-58.23479a32.jpg";